import { MoveRight, RotateCcw } from "lucide-react";
import DateInput from "../../date/DateInput";
import { DATE_FILTERS } from "../../../utils/dateFilters";
import { endDate, getDateBefore } from "../../../helpers/dateHelpers";
import LeftIconButton from "../../UI/buttonUI/LeftIconButton";

export const DateFilters = ({
  dateRange,
  setDateRange,
  getHistory,
  baseUrl,
  loaded,
  customeDateFilters,
}) => {
  const { currentSelector, start, end } = dateRange;
  const fetchHistory = (key, dateAgo) => {
    if (currentSelector !== key) {
      if (dateAgo) {
        const fromDate = getDateBefore(dateAgo);
        setDateRange((prev) => ({
          ...prev,
          currentSelector: key,
        }));
        getHistory(`${baseUrl}/${fromDate}/${endDate}`);
      } else {
        setDateRange((prev) => ({
          start: "",
          end: "",
          currentSelector: key,
        }));
      }
    }
  };

  const handleCustomeDate = (name, value) => {
    setDateRange((prev) => {
      const updatedRange = {
        ...prev,
        [name]: value,
      };

      const { start, end } = updatedRange;

      if (start && end && !loaded) {
        getHistory(`${baseUrl}/${start}/${end}`);
      }

      return updatedRange;
    });
  };

  const handleReset = () => {
    const fromDate = getDateBefore(30);
    setDateRange((prev) => ({
      start: "",
      end: "",
      currentSelector: "lastMonth",
    }));
    getHistory(`${baseUrl}/${fromDate}/${endDate}`);
  };
  const finalFilters = customeDateFilters ? customeDateFilters : DATE_FILTERS;

  return (
    <div className="bg-white border px-2 mt-2 py-2 border-gray-200 rounded-md">
      <div className="md:flex items-center">
        <div className="flex bg-blue-2 p-1 lg:p-2 rounded-lg">
          {finalFilters.map((f) => (
            <button
              key={f.key}
              onClick={() => fetchHistory(f.key, f.daysAgo)}
              className={`font-figtreeMedium text-[10px] lg:text-sm px-1 lg:px-3 py-1 rounded-md ${
                currentSelector === f.key
                  ? "bg-primary text-white"
                  : "text-blue-1 hover:text-primary"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>
        {dateRange.currentSelector === "custom" && (
          <div className="md:border-l-2 md:ml-2 border-gray-300 flex md:pl-2 gap-1 md:gap-2 items-center">
            <DateInput
              label="Start *"
              name="start"
              value={start}
              onChange={(e) => handleCustomeDate("start", e.target.value)}
            />
            <MoveRight color="gray" size={15} />
            <DateInput
              label="End *"
              name="end"
              value={end}
              onChange={(e) => handleCustomeDate("end", e.target.value)}
            />
          </div>
        )}
        {currentSelector !== "lastMonth" && (
          <LeftIconButton
            text="Reset"
            btnStyle="text-dark-blue bg-gray-200 hover:bg-gray-300 ml-2 max-lg:text-xs"
            Icon={RotateCcw}
            iconStyle="max-lg:w-4"
            size={15}
            onClick={handleReset}
          />
        )}
      </div>
    </div>
  );
};
